import { Checkbox } from "@/components/ui";
import type { Person } from "@/lib/api/types";

/** 활성 명단에서 여러 명 고르기. 주문 링크 만들기와 내기가 같은 한 벌을 쓴다.
 *
 * `active` 가 꺼진 사람은 애초에 목록에 넣지 않는다 — 명단에서 내린 사람이 주문이나
 * 내기에 끼면 명단 스위치가 아무 뜻도 없어진다. 걸러내는 책임은 이 컴포넌트가 진다.
 */
export function PeopleChecklist({
  people,
  selectedIds,
  onChange,
  emptyText = "활성 명단이 없어요.",
}: {
  people: Person[] | undefined;
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  emptyText?: string;
}) {
  const active = (people ?? []).filter((p) => p.active);
  const allSelected = active.length > 0 && selectedIds.length === active.length;

  return (
    <div>
      <div className="flex items-center justify-between">
        <span className="text-label-1 font-semibold text-label-normal">명단</span>
        <Checkbox
          label="전체 선택"
          checked={allSelected}
          onChange={() => onChange(allSelected ? [] : active.map((p) => p.id))}
          disabled={active.length === 0}
        />
      </div>
      {active.length === 0 ? (
        <p className="mt-2 text-body-2 text-label-alternative">{emptyText}</p>
      ) : (
        <ul className="mt-2 flex flex-col gap-2">
          {active.map((person) => (
            <li key={person.id}>
              <Checkbox
                label={person.name}
                checked={selectedIds.includes(person.id)}
                onChange={() =>
                  onChange(
                    selectedIds.includes(person.id)
                      ? selectedIds.filter((id) => id !== person.id)
                      : [...selectedIds, person.id]
                  )
                }
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
